'use client';

import { QueryKeys } from '@/constants/query-keys';
import { Theater } from '@cinemark/content-api-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useTheaterContext = (): ReturnType<typeof useQuery<Theater>> => {
  return useQuery({
    enabled: false,
    queryFn: (): Promise<Theater> => {
      // this should never actually run since we'll always have cached data
      // but we need a queryFn for TypeScript
      throw new Error('Theater context issue has occurred');
    },
    queryKey: QueryKeys.global.theaterContext,
    retry: false,
    staleTime: Infinity,
  });
};

export const useUpdateTheaterContext = (): ReturnType<typeof useMutation<void, unknown, Theater | undefined>> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (theater: Theater | undefined) => {
      if (theater === undefined) {
        queryClient.removeQueries({ queryKey: QueryKeys.global.theaterContext });
      } else {
        queryClient.setQueryData(QueryKeys.global.theaterContext, theater);
      }

      return Promise.resolve();
    },
  });
};
